import React from 'react'

function AboutSection() {
  return (
    <div>

      <div className='about-inner1-area sp1'></div>
  <div className="container">
    <div className="row">
      <div className="col-lg-6">
        <div className="about-widget-area1 heading1">
          <div className="img1">
            <img src="assets/img/all-images/about/talent_management.png" alt="JBY Talent Acquisition Management"/>
          </div>
          <div className="space32"></div>
           <div className="about2-boxarea">
            <div className="icons">
              <img src="assets/img/icons/about-icons3.svg" alt=""/>
            </div>
            <div className="text-area">
            
              <div className="space16"></div>
              <p>As a leading corporate talent acquisition and workforce management company in India, we help businesses streamline their HR operations with reliable, skilled, and performance-driven professionals who align with your company’s strategic goals.Our tailored approach ensures that every hire is more than just a placement—it’s a strategic investment in long-term organizational growth.</p>
            </div>
          </div>
          <div className="space24"></div>
          <div className="about2-boxarea">
            <div className="icons">
              <img src="assets/img/icons/about-icons4.svg" alt=""/>
            </div>
            <div className="text-area">
                <div className="space16"></div>
              <p>At JBY Talent Acquisition & Management Private Limited, we help corporates hire skilled and job-ready professionals while also supporting them with services like training, grooming, manpower planning, performance management (KRA/KPI), and company policy structuring. With a strong focus on quality and alignment, we ensure every talent we place contributes meaningfully to long-term business success.</p>
            </div>
          </div>
        </div>
      </div>

      <div className="col-lg-6">
        <div className="heading1">
          <h5 className="vl-section-subtitle"><svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 18 18" fill="none">
                <path d="M9.45001 17.8772C14.2115 17.6442 18 13.7338 18 8.94408C18 7.4743 17.6433 6.08732 17.0111 4.86399C14.4764 6.3183 13.2091 7.04546 12.2507 8.02546C11.1061 9.19582 10.2724 10.6308 9.82481 12.201C9.45001 13.5159 9.45001 14.9697 9.45001 17.8772Z" fill="#FB8500"></path>
                <path d="M8.55001 17.8772C3.78851 17.6442 0 13.7338 0 8.94408C0 7.47429 0.356744 6.08731 0.988876 4.86398C3.52358 6.3183 4.79093 7.04546 5.74937 8.02547C6.89397 9.19583 7.72761 10.6308 8.17521 12.2011C8.55001 13.5159 8.55001 14.9697 8.55001 17.8772Z" fill="#FB8500"></path>
                <path d="M1.43959 4.08981C3.97405 5.54399 5.24127 6.27107 6.57492 6.60594C8.16664 7.00559 9.83338 7.00559 11.4251 6.60594C12.7587 6.27108 14.026 5.54399 16.5604 4.08982C14.9571 1.62862 12.1699 0 9 0C5.8301 0 3.04295 1.62862 1.43959 4.08981Z" fill="#FB8500"></path>
              </svg> ABOUT US</h5>
              <div className="space16"></div>
              <h2 className="vl-section-title">JBY Talent Acquisition & Management Private Limited</h2>
              <div className="space16"></div>
              <p>We are a trusted partner for organizations seeking to hire the right talent and build high-performing, future-ready teams. We offer comprehensive corporate talent solutions, including manpower sourcing, employee training, professional grooming, performance management systems, KRA/KPI development, and company policy structuring.</p>
              <div className="space32"></div>
              <div className="img1">
                <img src="assets/img/all-images/about/talent_management_550X350.png" alt="JBY Talent Acquisition Management"/>
              </div>
        </div>
      </div>
    </div>
  </div>
</div>
    
  )
}

export default AboutSection;
